import {Ease} from "../../core/Animatable";
import {Callback} from "../../core/Reflection";
import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";

export class SlideInAnimation extends Animation {

    public readonly type: "up" | "down" | "left" | "right";

    constructor(type: "up" | "down" | "left" | "right") {
        super();
        this.type = type;
    }

    public animate(item: SceneItem, context: AnimationContext, cb: Callback): void {
        if (this.type === "up" || this.type === "down") {
            const y = this.toItemY(this.type === "up" ? 1536 + this.scenePadding : -this.scenePadding, item, context);
            item.moveYFrom(y, this.time || 1, this.getEase(Ease.sineOut), {
                delay: this.delay,
                onUpdate: () => {
                    this.updatePaperCut(item);
                    this.onUpdate();
                },
                onComplete: () => {
                    this.onComplete();
                    cb();
                },
            });
        } else {
            const x = this.type === "right" ? this.getRightmostPosition(item, context) : this.getLeftmostPosition(item, context);
            item.moveXFrom(x,
                this.time !== undefined ? this.time : Math.abs(item.x - x) / ((this.speed || 1) * 800),
                this.getEase(Ease.sineOut),
                {
                    delay: this.delay,
                    onUpdate: () => {
                        this.updatePaperCut(item);
                        this.onUpdate();
                    },
                    onComplete: () => {
                        this.onComplete();
                        cb();
                    },
                },
            );
        }
        if (this.delay) {
            this.updatePaperCut(item);
        }
    }
}
